import {DimensionValue, StyleSheet, ViewStyle} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {cloudLight, white} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';
const VIEWPORT_HEIGHT_WITHOUT_TAB_BAR: DimensionValue =
  `calc(100vh - ${TAB_BAR_HEIGH}px)` as DimensionValue;

export const styles = StyleSheet.create({
  base: {
    flex: 0,
    backgroundColor: white,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
  },
  basePadding: {
    paddingTop: indent * 1.1,
  },
  outerContainer: {
    flex: 1,
    backgroundColor: white,
    paddingHorizontal: indent * 1.5,
    paddingTop: indent * 1.5,
    paddingBottom: indent,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    height: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    maxHeight: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    overflow: 'hidden' as const,
    display: 'flex' as const,
    flexDirection: 'column' as const,
  },
  profileHeaderBlock: {
    position: 'relative' as const,
  },
  profileHeaderRow: {
    minHeight: 44,
    alignItems: 'center' as const,
    justifyContent: 'flex-start' as const,
    width: '100%' as const,
  },
  searchIconButton: {
    position: 'absolute' as const,
    right: indent,
    top: indent,
    padding: indent * 0.5,
    zIndex: 10,
  },
  searchIcon: {
    fontSize: 26,
    color: codGray,
  },
  scrollWrapper: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden' as const,
    marginTop: -(indent * 0.8),
  },
  header: {
    paddingBottom: indent * 2,
  } as ViewStyle,
  content: {
    flex: 1,
    minHeight: 0,
    backgroundColor: white,
    marginTop: 0,
    overflow: 'scroll' as const,
  },
  contentLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  viewMore: {
    borderTopWidth: 0,
    borderTopColor: cloudLight,
    backgroundColor: white,
    padding: 16,
  },
  viewMoreSection: {
    backgroundColor: white,
  },
  logoutContainer: {
    marginTop: indent,
    backgroundColor: white,
    paddingHorizontal: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    borderTopWidth: 0,
    borderTopColor: cloudLight,
    marginBottom: 50,
  },
  headerContainer: {
    zIndex: 1,
  },
  keyboardViewContainer: {
    paddingTop: 0,
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    marginHorizontal: 'auto',
    padding: 16,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    overflow: 'hidden' as const,
    height: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    maxHeight: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    paddingTop: indent * 2.275,
  },
  contentList: {
    flex: 1,
    minHeight: 0,
    overflow: 'scroll' as const,
  },
});
